import { useState } from "react";
import ReactLinkify from "react-linkify";

const TextShortener = ({fullText, words, toggleButtonColor, expandAction, uniqueClickAction}) => {
    const [isExpanded,setIsExpanded]=useState(false);
    const fullTextArray = fullText.split(' ');
    const shortText = `${fullText.split(' ').slice(0, words).join(' ')}`;

    const linkDecorator = (href, text, key) => (
        <a style={{color:"#0251EB",textDecoration:"none", wordBreak:"break-all"}} href={href} key={key} target="_blank" rel="noopener noreferrer">
          {text}
        </a>
      );

      const handleClick=()=>{
        if (uniqueClickAction) {
           expandAction();
        }else{
          setIsExpanded(prev => !prev);
        }
      };

    return ( 
        <pre>
            <ReactLinkify componentDecorator={linkDecorator}>
            {isExpanded ? fullText : shortText}
            {fullTextArray && fullTextArray.length > words && (
                      <button onClick={()=>handleClick()}
                      style={{backgroundColor:"transparent",
                              color:`${toggleButtonColor ? toggleButtonColor : "black"}`,
                              cursor:"pointer",
                              border:"none",
                              fontWeight:"bolder"
                      }}>
                          {isExpanded ? '  <<< Read Less' : '. . . Read More'}
                      </button>
            )}
            </ReactLinkify>
        </pre>
     );
}
export default TextShortener;